var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "monitor-page" },
    [
      _c(
        "pui-collapsible",
        { attrs: { expandable: false, headline: _vm.$t("processOverview") } },
        [
          _c(
            "pui-loader",
            { attrs: { promise: _vm.processPromise } },
            [
              _c("pui-table", {
                attrs: {
                  "vendor-options": _vm.vendorOptions,
                  "first-column-is-sticky": "",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "process",
                      fn: function (data) {
                        return [
                          _vm._v(" " + _vm._s(_vm.$t(data.row.process)) + " "),
                        ]
                      },
                    },
                    _vm._l(_vm.VALUE_CELLS, function (valueCell) {
                      return {
                        key: valueCell,
                        fn: function (data) {
                          return [
                            _c("table-cell", {
                              key: valueCell,
                              attrs: {
                                "history-flag": data.row[valueCell].history,
                                "current-flag": data.row[valueCell].current,
                                date: data.row[valueCell].date,
                                "is-legend-clickable": true,
                              },
                              on: {
                                legendClicked: function ($event) {
                                  return _vm.goToDetails(
                                    data.row.process,
                                    valueCell,
                                    $event.overviewValueType
                                  )
                                },
                              },
                            }),
                          ]
                        },
                      }
                    }),
                  ],
                  null,
                  true
                ),
              }),
              _c("div", { staticClass: "monitor-page__legend-row" }, [
                _c(
                  "div",
                  { staticClass: "monitor-page__legend-row__legends" },
                  [
                    _c("legend-item", {
                      attrs: {
                        "status-color": _vm.PUICOLOR_DARK_GREY,
                        "status-label": _vm.$t("historyShort"),
                        "label-color": _vm.PUICOLOR_DARK_GREY,
                        label: _vm.$t("history"),
                        "label-font-size": "1.2rem",
                      },
                    }),
                    _c("legend-item", {
                      attrs: {
                        "status-color": _vm.PUICOLOR_DARK_GREY,
                        "status-label": _vm.$t("currentShort"),
                        "label-color": _vm.PUICOLOR_DARK_GREY,
                        label: _vm.$t("current"),
                        "label-font-size": "1.2rem",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "monitor-page__legend-row__legends" },
                  _vm._l(_vm.IMPORT_STATUSES, function (status) {
                    return _c("legend-item", {
                      key: status,
                      attrs: {
                        "status-color": _vm.PROCESS_STATUS[status].color,
                        "label-color": _vm.PUICOLOR_DARK_GREY,
                        label: _vm.$t(_vm.PROCESS_STATUS[status].status),
                      },
                    })
                  }),
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c("pui-date-bottom-bar", {
        attrs: {
          range: _vm.range,
          "options-selector-configuration": _vm.optionsSelectorConfiguration,
          "options-selector-model": _vm.optionsSelectorModel,
          "show-timezone": false,
          "auto-refresh-items": _vm.optionsAutoRefresh,
          "auto-refresh-label": _vm.remainingRefreshTime,
        },
        on: {
          "update:optionsSelectorModel": function ($event) {
            _vm.optionsSelectorModel = $event
          },
          "update:options-selector-model": function ($event) {
            _vm.optionsSelectorModel = $event
          },
          "change:pui-auto-refresh": _vm.refreshIntervalChanged,
          "update:range": _vm.rangeChanged,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }